"use strict";

exports.__esModule = true;
exports.downloadTableData = void 0;
exports.getFormattedData = getFormattedData;
exports.getFormattedRows = void 0;
exports.showDataTableContextMenu = showDataTableContextMenu;
var _react = _interopRequireDefault(require("react"));
var _core = require("@blueprintjs/core");
var _icons = require("@blueprintjs/icons");
var _reactIntl = require("react-intl");
var _Utils = require("../../../Utils");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function formatRow(columns) {
  return function (row) {
    var colsFastFind = columns.reduce(function (acc, col) {
      acc[col.id] = col;
      return acc;
    }, {});
    return Object.keys(row).reduce(function (acc, key) {
      var cell = row[key];
      if (colsFastFind[key]) {
        acc[key] = colsFastFind[key].DownloadCellFormatter(row);
      } else {
        acc[key] = cell;
      }
      return acc;
    }, {});
  };
}
function getFormattedData(columns, data) {
  var formattedRows = data.map(formatRow(columns));
  var template = {
    columns: columns.filter(function (col) {
      return col.id !== "actions";
    }).reduce(function (acc, col) {
      acc[col.id] = col.name;
      return acc;
    }, {})
  };
  return (0, _Utils.exportDataToCSVFormat)(formattedRows, template);
}
var downloadTableData = exports.downloadTableData = function downloadTableData(columns, data, getDataForCSV) {
  return (0, _Utils.downloadCSVData)(typeof getDataForCSV === "function" ? getDataForCSV(columns, data) : getFormattedData(columns, data), "Table");
};
function showDataTableContextMenu(_ref) {
  var e = _ref.e,
    translator = _ref.translator,
    columns = _ref.columns,
    data = _ref.data,
    getDataForCSV = _ref.getDataForCSV,
    loadData = _ref.loadData;
  e.preventDefault();
  var menu = /*#__PURE__*/_react["default"].createElement(_reactIntl.IntlProvider, translator.intl, /*#__PURE__*/_react["default"].createElement(_core.Menu, {
    "data-testid": "ContextMenu"
  }, /*#__PURE__*/_react["default"].createElement(_core.MenuItem, {
    icon: _icons.IconNames.DOWNLOAD,
    text: /*#__PURE__*/_react["default"].createElement(_reactIntl.FormattedMessage, {
      id: "ContextMenu.download",
      defaultMessage: "Download"
    }),
    onClick: function onClick() {
      var rows = loadData ? loadData() : data;
      Promise.resolve(rows).then(function (resolved) {
        return downloadTableData(columns, resolved, getDataForCSV);
      });
    }
  })));
  (0, _core.showContextMenu)({
    content: menu,
    targetOffset: {
      left: e.clientX,
      top: e.clientY
    }
  });
}
var getFormattedRows = exports.getFormattedRows = function getFormattedRows(columns, data) {
  return data.map(formatRow(columns));
};